module.exports = __webpack_public_path__ + "static/media/balance_5_15가지음료.e7f40ee3.jpg";